export default __webpack_public_path__ + "static/media/logo.61a01487.gif";